import React, { useState } from 'react';
import { Box, TextField } from "@mui/material";
import { FormEditActions } from '@arelia-components/form/FormEditActions';

type Props = {
  initialName: string;
  onSave: (text: string) => void;
};

export default function CampaignName({ initialName, onSave }: Props) {
  const [name, setName] = useState(initialName);
  const [editing, setEditing] = useState(false);

  const handleReset = () => {
    setName(initialName);
    setEditing(false);
  };

  const handleSubmit = () => {
    onSave(name);
    setEditing(false);
  };

  const nameplace = editing
    ? (
      <TextField
        focused={true}
        autoFocus={true}
        value={name}
        size="medium"
        type="text"
        color="primary"
        onChange={(e) => setName(e.target.value)}
        InputProps={{
          style: {
            fontSize: "55px",
            fontWeight: 700,
            lineHeight: "1.2",
            marginBottom: "12px",
            fontFamily: "Montserrat",
            color: "#F7F8FA"
          }
        }}
      />
    )
    : name;

  return (
    <Box sx={styles.titleBox}>
      <Box sx={styles.title}>
        {nameplace}
        <FormEditActions 
          edit={editing} 
          handleEdit={() => setEditing(true)} 
          handleReset={handleReset} 
          handleSubmit={handleSubmit} 
        />
      </Box>
    </Box>
  );
}

const styles = {
  titleBox: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    marginTop: "20px",
    width: "100%"
  },
  title: {
    display: "flex",
    alignItems: "center",
    gap: "20px"
  }
};